var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-section-title"},[_c('div',{staticClass:"title-content flex col-center"},[_c('div',{staticClass:"title-tag"}),_c('div',{staticClass:"m-l-6"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.title))]})],2)]),_c('div',{staticClass:"right-tool"},[_vm._t("right-tool")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }